import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function UniqueNameValidation(names: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (names?.length) {
            return !names.find((x) => x.trim().toLowerCase().replace(/\s/g, '') == control?.value?.trim()?.toLowerCase()?.replace(/\s/g, ''))
                ? null
                : {
                      duplicateName: true,
                  };
        }
        return;
    };
}
